import React from 'react';
import { IDashboardWidgetsProps, useDashboardWidgetsState } from './DashboardWidgets.State';
import DashboardWidgetsView from './DashboardWidgets.View';

const DashboardWidgets: React.FC<IDashboardWidgetsProps> = (props) => {
    const state = useDashboardWidgetsState(props);

    return <DashboardWidgetsView {...state} />;
};

export default DashboardWidgets;
